export default __webpack_public_path__ + "static/media/sa-icon-active.eb3645d3.svg";